import styled from "styled-components";
import { Colors } from "../../constants/Colors";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 2rem;
    height: calc(100vh - 64px);
    width: 100vw;

    background-color: ${Colors.commons.gray};
    position: relative;

    padding-bottom: 6rem;
`;

export const EmptyList = styled.div`
    font-size: 1.25rem;
    margin: 0.5rem;
`

export const VehicleList = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    flex: 1;
    gap: 1rem;
    overflow-y: auto;
`

export const UpdateButton = styled.button`
    position: absolute;
    top: calc(50% - 2rem);
    left: calc(50% - 4rem);

    width: 8rem;
    height: 4rem;
    border-radius: 0.5rem;

    border: none;
    background-color: ${Colors.primary[100]};
    color: ${Colors.commons.white};
    font-size: 1.5rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0.235rem 0.235rem 0.2rem rgba(0,0,0,0.25);
`;

export const ButtonRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  margin-top: 1rem;
  margin-bottom: 1rem;
  overflow-x: auto;
  padding-bottom: 0.5rem;
`;

export const VehicleButton = styled.button<{ $highlight?: boolean }>`
  background-color: ${({ $highlight }) =>
    $highlight ? Colors.secondary[100] : Colors.primary[100]};
  color: ${Colors.commons.white};
  border: ${({ $highlight }) =>
    $highlight ? `2px solid ${Colors.secondary[100]}` : "none"};
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  font-size: 1.5rem;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0.15rem 0.15rem 0.2rem rgba(0, 0, 0, 0.25);
  transition: 0.2s;

  &:hover {
    opacity: 0.9;
    transform: scale(1.03);
  }
`;
